module.exports = __webpack_public_path__ + "img/AAA质量服务诚信单位认证证书-tuya.9b818d7d.png";